<template>
  <div class="candidate profile flags">
    <can I="read" a="Profile">
      <v-toolbar class="transparent elevation-0 my-3">
        <div class="headline">Flags</div>
      </v-toolbar>

      <v-card class="mt-2">
        <v-card-title v-if="total <= 0">
          Candidate has no flags
        </v-card-title>

        <List v-else :value="flags" :total="total" @refresh="$emit('refresh')" />
      </v-card>
    </can>
  </div>
</template>

<script>
// Components
import List from '@/components/flags/List'

// Data
import flagsConfig from '@/data/flags'

// Helpers
import { mapState } from 'vuex'

export default {
  components: { List },

  created() {},

  props: { value: { type: Array, required: true } },

  data() {
    return { flagsConfig }
  },

  computed: {
    ready() {
      return this.value && this.value.length && this.flagsConfig
    },
    total() {
      if (!this.ready) return 0

      return this.value.length
    },

    flags() {
      if (!this.ready) return []

      return this.value.map(flag => ({...flag, ...this.flagData(flag)}))
    },
  },

  methods: {
    flagData(flag) {
      if (!this.ready) return {}

      return this.flagsConfig.find(config => config.key === flag.key)
    },
  },
}
</script>
